/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.feature.rollouts.app.rpc.BetaAccessRolloutRpc
 */

/* @bend-expect import-missing-runtime-dep */
import { useMemo } from 'react';
import {
  useMutation,
  MutationHookOptions,
  MutationTuple,
} from 'data-fetching-client';
import * as References from './BetaAccessRolloutRpc';
import * as Queries from './BetaAccessRolloutRpc.dfc.new';
import type { AdditionalContextArgs } from './BetaAccessRolloutRpc.dfc.new';

type OverrideData<TTuple extends [any, any], TNewData> = [
  TTuple[0],
  Omit<TTuple[1], 'data'> & { data?: TNewData },
];

type MutationTupleOverride<Response, Request, DataOverride> = OverrideData<
  MutationTuple<Response, Request>,
  DataOverride
>;

type UseEnrollMutationReturn<T extends boolean> = MutationTupleOverride<
  Record<'result', References.EnrollResponseType>,
  References.EnrollRequestType,
  T extends true
    ? Record<'enroll', References.EnrollResponseType>
    : References.EnrollResponseType
>;

export function useEnrollMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.EnrollResponseType>,
    References.EnrollRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseEnrollMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.ENROLL_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            enroll: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseEnrollMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseEnrollMutationReturn<T>;
}

type UseUpdateEnrollTypeMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.UpdateEnrollTypeResponseType>,
    References.UpdateEnrollTypeRequestType,
    T extends true
      ? Record<'updateEnrollType', References.UpdateEnrollTypeResponseType>
      : References.UpdateEnrollTypeResponseType
  >;

export function useUpdateEnrollTypeMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.UpdateEnrollTypeResponseType>,
    References.UpdateEnrollTypeRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseUpdateEnrollTypeMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.UPDATE_ENROLL_TYPE_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            updateEnrollType: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseUpdateEnrollTypeMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseUpdateEnrollTypeMutationReturn<T>;
}

type UseLeaveMutationReturn<T extends boolean> = MutationTupleOverride<
  Record<'result', References.LeaveResponseType>,
  References.LeaveRequestType,
  T extends true
    ? Record<'leave', References.LeaveResponseType>
    : References.LeaveResponseType
>;

export function useLeaveMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.LeaveResponseType>,
    References.LeaveRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseLeaveMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.LEAVE_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            leave: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseLeaveMutationReturn<T>;
  }
  return [getter, { data: data?.result, ...rest }] as UseLeaveMutationReturn<T>;
}
